import {lazy} from 'react';

export const SpecialistChatsAsync = lazy(() =>
    import('./SpecialistChats')
);
